import { render, staticRenderFns } from "./tutoriales.vue?vue&type=template&id=9e5fec12&scoped=true&"
var script = {}
import style0 from "./tutoriales.vue?vue&type=style&index=0&id=9e5fec12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e5fec12",
  null
  
)

export default component.exports